import BaseEvent from "../util/baseEvent"
import { SIGNAL, TIMEROUT, ENGINE } from "../util/eventTypes"
import UserEvents from "./userEvents"
import SignalSDK from "../core/signalCore/index"
import MESSAGE from "../util/message"
class Signal extends BaseEvent {
  // 初始化
  constructor(version = "v1") {
    super()
    this.version = version
    this.UserEvents = UserEvents
    this.initRoomInfo = {}
    this.signalParams = null
    // this.enterParams = enterParams
  }
  enterRoom(enterParams) {
    this.$logger.setPrefix("signal")
    return new Promise((resolve, reject) => {
      let {
        userId,
        roomId,
        token,
        vendor,
        userRole,
        signalSdk,
        product
      } = enterParams
      return this.init({
        roomid: roomId,
        userid: userId,
        role: userRole,
        alias: enterParams.nickname || "",
        token: token,
        vendor: vendor,
        idcList: signalSdk.idcList,
        wsStaticList: signalSdk.wsStaticList.slice(0),
        timelineList: signalSdk.recordUrl,
        logModel: 3,
        env: "web",
        product
      })
        .then(res => {
          this.$logger.info(ENGINE.SIGNAL_ENTER_WEBSERVER_SUCCESS)
          resolve(Object.assign({}, res))
        })
        .catch(err => {
          this.$logger.error(ENGINE.SIGNAL_ENTER_WEBSERVER_FAIL, err)
          reject(new Error(err))
        })
    })
  }
  init(options) {
    this.signalParams = Object.assign({}, options)
    this.engine = new SignalSDK(options, this.version)
    this.engine.userid = options.userid
    this.engine.connect()
    return new Promise((resolve, reject) => {
      // 监听成功连接
      this.engine.on("connected", res => {
        // 初始化事件
        this.$logger.info(SIGNAL.ENTER_SIGNAL_ROOM_SUCCESS)
        this.initRoomInfo = Object.assign({}, res)
        this.initEvents()
        resolve({ status: 1, res: res })
      })
      // 监听失败
      // see lib/signalCore/index.ts:addEventLisenter()
      this.engine.on("discoverError", reason => {
        reject(new Error(reason))
      })
    })
  }
  initEvents() {
    // 初始化聊天信息
    // this.initChat();
    // 初始化聊天室相关
    this.initChatRoom()
    // 初始化公告栏
    this.initBorad()
    // 初始化摄像头和麦克风信息
    this.initMedia()

    // 初始化中心区域展示课件或者视频相关
    this.initSwitchVideoPPT()

    // 初始化视频信息
    this.initVideoMsg()

    // 监听消息
    this.engine.on("message", res => {
      console.log("============203-message====================", res)
      let { msgid } = res
      let { msg } = res
      // let {srcmsgid,data}=msg;
      if (msgid === "203") {
        this.$logger.info(SIGNAL.INIT_BROAD_EVENT, res)
        this.initBroadcastEvents(res)
      }
      if (msgid === "208") {
        this.emit("INTERACTIVE_CLASS", msg)
      }
    })
    // 监听重连
    this.engine.on("reconnect", (status, params) => {
      this.$logger.error("SIGNAL_RECONNECT", status)
      this.emit("SIGNAL_RECONNECT", status, params)
    })
    // 信令报活失败
    this.engine.on("KEEP_ALIVE_FAIL", data => {
      this.$logger.error("KEEP_ALIVE_FAIL", data)
      this.emit("KEEP_ALIVE_FAIL", data)
    })
    // 信令报活时间
    this.engine.on("KEEP_ALIVE_DEALYTIME", time => {
      this.emit("KEEP_ALIVE_DEALYTIME", time)
    })
    // 监听被踢
    this.engine.on("USER_ROOM_KICKOFF", data => {
      this.$logger.error("USER_ROOM_KICKOFF", data)
      this.emit("USER_ROOM_KICKOFF", data)
    })
    // 信令服务出错
    this.engine.on("USER_SIGNAL_EXCEPTION", data => {
      this.$logger.error("USER_SIGNAL_EXCEPTION", data)
      this.emit("USER_SIGNAL_EXCEPTION", data)
    })
  }
  initBroadcastEvents(res) {
    let { msg } = res
    let { msgtype, data } = msg
    this.$logger.info(`${MESSAGE[msgtype]}`, {
      msgtype,
      data,
      res
    })
    switch (msgtype) {
      case MESSAGE.SIGANL_TYPE_ENTERSIGNALROOM: {
        if (msg.role === "1") {
          this.emit("TEACHER_ENTER_ROOM", res)
        }
        this.emit("USER_ENTERROOM", res)
        // this.emit('GET_USER_NUMBER', data)
        break
      }
      case MESSAGE.SIGANL_TYPE_LEAVESIGNALROOM: {
        if (msg.role === "1") {
          this.emit("TEACHER_LEAVE_ROOM", res)
        }
        this.emit("USER_LEAVEROOM", res)
        // this.emit('GET_USER_NUMBER', data)
        break
      }
      case MESSAGE.SIGANL_TYPE_PPTTURNINGPAGE: {
        let pptSlideData = JSON.parse(data)
        this.emit("BOARD_PPT_SLIDE_CHANGE", {
          pageindex: pptSlideData["page"],
          currentPage: pptSlideData["page"],
          docId: pptSlideData["docId"],
          uuid: pptSlideData["docId"],
          slideCount: pptSlideData["slideCount"]
        })
        break
      }
      case MESSAGE.SIGANL_TYPE_PPTDRAWLINE: {
        let { color, content } = JSON.parse(data)

        this.emit("BOARD_PPT_DRAW_LINE", {
          color,
          content,
          role: msg.role,
          uid: msg.userid,
          username: msg.alias.split("|")[0]
        })
        break
      }
      case MESSAGE.SIGANL_TYPE_PPTCLEAR:
        this.emit("BOARD_PPT_CLEAR", {})
        break
      case MESSAGE.SIGANL_TYPE_CHANGEPPT: {
        let pptPresentationData = JSON.parse(data)
        this.emit("BOARD_PPT_PRESENTATION_CHANGED", {
          pageindex: pptPresentationData["page"],
          currentPage: pptPresentationData["page"],
          uuid: pptPresentationData["docId"],
          docId: pptPresentationData["docId"],
          slideCount: pptPresentationData["slideCount"]
        })
        break
      }
      case MESSAGE.SIGANL_TYPE_OPENVIDEO:
        this.emit("OPEN_VIDEO", {})
        break
      case MESSAGE.SIGANL_TYPE_CLOSEVIDEO:
        this.emit("CLOSE_VIDEO", {})
        break
      case MESSAGE.SIGANL_TYPE_SILENCEALL:
        this.emit("NOT_ALLOW_TALK", {})
        break
      case MESSAGE.SIGANL_TYPE_ENABLECHAT:
        this.emit("ALL_TALK", {})
        break
      case MESSAGE.SIGANL_TYPE_ANNOUNCEMENT:
        this.emit("BOARD_MESSAGE", {
          msg: data
        })
        break
      case MESSAGE.SIGANL_TYPE_SLIENCESOMEONE:
        if (Number(msg.data.userid) === Number(this.signalParams.userid)) {
          this.emit("CHATBOX_SLIENT")
        }
        break
      case MESSAGE.SIGANL_TYPE_ENABLESOMEONETALK:
        if (Number(msg.data) === Number(this.signalParams.userid)) {
          this.emit("CANCEL_CHATBOX_SLIENT")
        }
        break
      case MESSAGE.SIGANL_TYPE_SETMSGINTERVAL:
        this.emit("SET_MESSAGE_INTERVAL", JSON.parse(data))
        break
      case MESSAGE.SIGANL_TYPE_CHATMESSAGE:
        this.emit("CHAT_MESSAGE", data)
        break
      case MESSAGE.SIGANL_TYPE_SHOWUSERCOUNT:
        this.emit("SHOW_ONLINE_USERNUM")
        break
      case MESSAGE.SIGANL_TYPE_HIDEUSERCOUNT:
        this.emit("HIDE_ONLINE_USERNUM")
        break
      case MESSAGE.SIGANL_TYPE_INITMP4:
        this.emit("INIT_VIDEO_MP4", JSON.parse(data))
        break
      case MESSAGE.SIGANL_TYPE_SEEKMP4:
        this.emit("SEEK_VIDEO_MP4", JSON.parse(data))
        break
      case MESSAGE.SIGANL_TYPE_PAUSEMP4:
        console.log("学生受到46消息----->")
        this.emit("PAUSE_VIDEO_MP4", JSON.parse(data))
        break
      case MESSAGE.SIGANL_TYPE_PLAYMP4:
        console.log("学生受到47消息----->")
        this.emit("PLAY_VIDEO_MP4", JSON.parse(data))
        break
      case MESSAGE.SIGANL_TYPE_CLOSEMP4:
        this.emit("CLOSE_VIDEO_MP4")
        break
      case MESSAGE.SIGANL_TYPE_SWITCHSCREEN:
        this.emit("SWITCH_PPT_VIDEO", data)
        break
      case MESSAGE.SIGANL_TYPE_INTERACTIVE_STARTQUIZ:
      case MESSAGE.SIGANL_TYPE_INTERACTIVE_ANSWER:
      case MESSAGE.SIGANL_TYPE_INTERACTIVE_COLLECTANSWERS:
        // console.log('sum vote type====', msgtype)
        this.emit("INTERACTIVE_CLASS_PUBLIC_VOTE", JSON.stringify(msg))
        break
      case MESSAGE.SIGANL_TYPE_CUSTOM_MESSAGE:
        this.emit("receive_custom_message", JSON.parse(data))
        break
      default:
        break
    }
  }
  // 离开教室
  exitRoom() {
    this.destroy()
    return new Promise((resolve, reject) => {
      this.engine.destroy()
      this.$logger.info("EXIT_SIGNAL_ROOM_SUCCESS")
      resolve({ status: 1 })
    })
  }
  // 初始化视频信息
  initVideoMsg() {
    let { coursewarevideo } = this.initRoomInfo
    let {
      progress_bar,
      seek_timestamp,
      status,
      time_length,
      url
    } = coursewarevideo
    this.emit("INIT_VIDEO_MP4", {
      progress_bar,
      seek_timestamp,
      status,
      time_length,
      url
    })
  }
  // 初始化聊天消息列表
  initChat() {
    let { chatmsg = [] } = this.initRoomInfo
    chatmsg = chatmsg || []
    if (!chatmsg || !chatmsg.length) {
      return
    }
    chatmsg = chatmsg.map(item => {
      try {
        item = JSON.parse(item)
      } catch (ex) {
        item = { msg: {} }
      }
      item.alias = item.msg.alias || ""
      item.data = item.msg.data
      delete item.msg
      delete item.msgid
      delete item.roomid
      delete item.usernum
      return item
    })
    this.emit("CHAT_MESSAGE", chatmsg)
  }
  initChatRoom() {
    let {
      usernum,
      silence,
      silenced,
      chatinterval,
      userlist,
      usernumshow
    } = this.initRoomInfo
    this.initChat()
    if (usernumshow === "on" || usernumshow === "") {
      this.emit("SHOW_ONLINE_USERNUM")
    } else {
      this.emit("HIDE_ONLINE_USERNUM")
    }
    try {
      chatinterval = JSON.parse(chatinterval)
    } catch (e) {
      chatinterval = 1
    }

    this.emit("GET_USER_NUMBER", usernum)
    this.emit("INIT_ALLOW_CHATWITHMESSAGE", silence)
    this.emit("INIT_SILENCE", silenced)
    this.emit("SET_MESSAGE_INTERVAL", chatinterval)
    let isTeacherOnline = false

    for (let i = 0; i < userlist.length; i++) {
      if (userlist[i].role === "1" && userlist[i].online === "1") {
        isTeacherOnline = true
        break
      }
    }
    this.emit("GET_TEACHER_ONLINE_STATUS", isTeacherOnline)
  }
  // 初始化公告栏
  initBorad() {
    let { annoucement } = this.initRoomInfo
    this.emit("INIT_BOARD_MESSAGE", { msg: annoucement })
  }
  // 初始化摄像头和麦克风
  initMedia() {
    let { camera } = this.initRoomInfo
    this.emit("INIT_CAMERA_STATUS", camera)
  }
  // 初始化中心区域展示课件或者视频相关
  initSwitchVideoPPT() {
    let { centercontent } = this.initRoomInfo
    this.emit("INIT_SWITCH_PPT_VIDEO", centercontent)
  }
  // PPT初始化
  initPresentation() {
    // let ppt
    // let { role } = this.signalParams
    // if (
    //   this.initRoomInfo.ppt === '' ||
    //   JSON.parse(this.initRoomInfo.ppt).docId === ''
    // ) {
    //   ppt = this.signalParams.ppt
    // } else {
    //   ppt = this.initRoomInfo.ppt
    // }
    // try {
    //   ppt = JSON.parse(ppt)
    // } catch (ex) {
    //   ppt = {}
    // }
    // let { docId = '', page = 1, slideCount = 0 } = ppt
    // if (slideCount == 0) {
    //   page = '0'
    // }
    // let { role } = this.signalParams;
    // let sn = GetUrlParam("lessonSerialNumber");
    // if (+role === 1) {
    //   this.sendPresentationChange(1, 0, sn, sn).then(() => {
    //     this.log("signal sendPresentationChange success");
    //   });
    // }
    // this.emit('BOARD_PPT_PRESENTATION_CHANGED', {
    //   currentPage: page,
    //   slideUrl: '',
    //   uuid: docId,
    //   slideCount
    // })
  }
  // 打开PPT
  sendPresentationChange(currentPage, slideCount, docId) {
    return new Promise((resolve, reject) => {
      this.engine.sendMessage(
        {
          msgid: "203",
          msg: {
            msgtype: "12",
            data: JSON.stringify({
              docId,
              page: currentPage,
              slideCount
            })
          }
        },
        (data, code) => {
          if (code === "SUCCESS") {
            this.$logger.info(SIGNAL.RESEIVE_PPT_CHANGE_SUCCESS, data)
            resolve(data)
          } else {
            this.$logger.error(SIGNAL.RESEIVE_PPT_CHANGE_FAIL, data)
            reject(`sendPresentationChange->${new Error()}失败原因是${data}`)
          }
        },
        TIMEROUT.RESEIVE_MESSAGE_TIMEOUT
      )
    })
  }
  // 发送聊天消息
  sendTextMessage(text) {
    return new Promise((resolve, reject) => {
      this.engine.sendMessage(
        {
          msgid: "203",
          msg: {
            msgtype: "41",
            data: text
          }
        },
        (data, code) => {
          if (code === "SUCCESS") {
            this.$logger.info(SIGNAL.RESEIVE_TEXT_MESSAGE_SUCCESS, data)
            resolve(data)
          } else {
            this.$logger.error(SIGNAL.RESEIVE_TEXT_MESSAGE_FAIL, data)
            reject(`sendTextMessage->${new Error()}失败原因是${data}`)
          }
        },
        TIMEROUT.RESEIVE_MESSAGE_TIMEOUT
      )
    })
  }
  // 发送公告栏
  sendBroadMessage(text) {
    return new Promise((resolve, reject) => {
      this.engine.sendMessage(
        {
          msgid: "203",
          msg: {
            msgtype: "34",
            data: text
          }
        },
        (data, code) => {
          if (code === "SUCCESS") {
            this.$logger.info(SIGNAL.RESEIVE_BROAD_MESSAGE_SUCCESS, data)
            resolve(data)
          } else {
            this.$logger.error(SIGNAL.RESEIVE_BROAD_MESSAGE_FAIL, data)
            reject(`sendTextMessage->${new Error()}失败原因是${data}`)
          }
        },
        TIMEROUT.RESEIVE_MESSAGE_TIMEOUT
      )
    })
  }
  // 打开摄像头消息
  sendOpenVideoMessage() {
    this.engine.sendMessage({
      msgid: "203",
      msg: {
        msgtype: "13",
        data: "open_video"
      }
    })
  }
  // 关闭摄像头消息
  sendCloseVideoMessage() {
    this.engine.sendMessage({
      msgid: "203",
      msg: {
        msgtype: "14",
        data: "close_video"
      }
    })
  }
  // PPT跳页
  sendGoToSlide(page, docId, slideCount) {
    return new Promise((resolve, reject) => {
      this.engine.sendMessage(
        {
          msgid: "203",
          msg: {
            msgtype: "9",
            data: JSON.stringify({
              docId,
              page,
              slideCount
            })
          }
        },
        (data, code) => {
          if (code === "SUCCESS") {
            this.$logger.info(SIGNAL.RESEIVE_GOTO_SLIDE_SUCCESS, data)
            resolve(data)
          } else {
            this.$logger.error(SIGNAL.RESEIVE_GOTO_SLIDE_FAIL, data)
            reject(`sendGoToSlide->${new Error()}失败原因是${data}`)
          }
        },
        TIMEROUT.RESEIVE_MESSAGE_TIMEOUT
      )
    })
  }
  // 划线
  sendDrawLine(config) {
    return new Promise((resolve, reject) => {
      this.engine.sendMessage(
        {
          msgid: "203",
          msg: {
            msgtype: "10",
            data: JSON.stringify({
              color: config.color,
              content: config.content
            })
          }
        },
        (data, code) => {
          if (code === "SUCCESS") {
            this.$logger.info(SIGNAL.RESEIVE_DRAW_LINE_SUCCESS, data)
            resolve(data)
          } else {
            this.$logger.error(SIGNAL.RESEIVE_DRAW_LINE_FAIL, data)
            reject(`sendDrawLine->${new Error()}失败原因是${data}`)
          }
        },
        TIMEROUT.RESEIVE_MESSAGE_TIMEOUT
      )
    })
  }
  // 清屏
  sendClear() {
    return new Promise((resolve, reject) => {
      this.engine.sendMessage(
        {
          msgid: "203",
          msg: {
            msgtype: "11"
          }
        },
        (data, code) => {
          if (code === "SUCCESS") {
            this.$logger.info(SIGNAL.RESEIVE_CLEAR_SUCCESS, data)
            resolve(data)
          } else {
            this.$logger.error(SIGNAL.RESEIVE_CLEAR_FAIL, data)
            reject(`sendClear->${new Error()}失败原因是${data}`)
          }
        },
        TIMEROUT.RESEIVE_MESSAGE_TIMEOUT
      )
    })
  }
  // 开始投票
  startPublicVote(page, options) {
    return new Promise((resolve, reject) => {
      this.engine.sendMessage(
        {
          msgid: "209",
          msg: {
            msgtype: "71",
            data: JSON.stringify({
              pageid: page,
              options
            })
          }
        },
        (data, code) => {
          if (code === "SUCCESS") {
            this.$logger.info(SIGNAL.RESEIVE_START_PUBLIC_VOTE_SUCCESS, data)
            resolve(data)
          } else {
            this.$logger.error(SIGNAL.RESEIVE_START_PUBLIC_VOTE_FAIL, data)
            reject(`startPublicVote->${new Error()}失败原因是${data}`)
          }
        },
        TIMEROUT.RESEIVE_MESSAGE_TIMEOUT
      )
    })
  }
  // 投票
  submitPublicVote(page, options) {
    return new Promise((resolve, reject) => {
      this.engine.sendMessage(
        {
          msgid: "209",
          msg: {
            msgtype: "72",
            data: JSON.stringify({
              pageid: page,
              options
            })
          }
        },
        (data, code) => {
          if (code === "SUCCESS") {
            this.$logger.info(SIGNAL.RESEIVE_SUBMIT_PUBLIC_VOTE_SUCCESS, data)
            resolve(data)
          } else {
            this.$logger.error(SIGNAL.RESEIVE_SUBMIT_PUBLIC_VOTE_FAIL, data)
            reject(`startPublicVote->${new Error()}失败原因是${data}`)
          }
        },
        TIMEROUT.RESEIVE_MESSAGE_TIMEOUT
      )
    })
  }
  // 收集选项
  collectPublicVote(page) {
    return new Promise((resolve, reject) => {
      this.engine.sendMessage(
        {
          msgid: "209",
          msg: {
            msgtype: "73",
            data: JSON.stringify({
              pageid: page
            })
          }
        },
        (data, code) => {
          if (code === "SUCCESS") {
            this.$logger.info(SIGNAL.RESEIVE_COLLECT_PUBLIC_VOTE_SUCCESS, data)
            resolve(data)
          } else {
            this.$logger.error(SIGNAL.RESEIVE_COLLECT_PUBLIC_VOTE_FAIL, data)
            reject(`startPublicVote->${new Error()}失败原因是${data}`)
          }
        },
        TIMEROUT.RESEIVE_MESSAGE_TIMEOUT
      )
    })
  }
  // 禁言设置
  chatboxSlient() {
    return new Promise((resolve, reject) => {
      this.engine.sendMessage(
        {
          msgid: "203",
          msg: {
            msgtype: "19"
          }
        },
        (data, code) => {
          if (code === "SUCCESS") {
            resolve(data)
          } else {
            reject(`slient->${new Error()}失败原因是${data}`)
          }
        }
      )
    })
  }
  // 取消禁言设置
  cancelChatboxSlient() {
    return new Promise((resolve, reject) => {
      this.engine.sendMessage(
        {
          msgid: "203",
          msg: {
            msgtype: "20"
          }
        },
        (data, code) => {
          if (code === "SUCCESS") {
            resolve(data)
          } else {
            reject(`slient->${new Error()}失败原因是${data}`)
          }
        }
      )
    })
  }
  // 禁言某个学生
  silenceAStudent(options) {
    return new Promise((resolve, reject) => {
      this.engine.sendMessage(
        {
          msgid: "203",
          msg: {
            msgtype: "36",
            data: options
          }
        },
        (data, code) => {
          if (code === "SUCCESS") {
            resolve(data)
          } else {
            reject(`slientAStudent->${new Error()}失败原因是${data}`)
          }
        }
      )
    })
  }
  // 解禁言某个学生
  disSilenceAStudent(studentId) {
    return new Promise((resolve, reject) => {
      this.engine.sendMessage(
        {
          msgid: "203",
          msg: {
            msgtype: "37",
            data: JSON.stringify(studentId)
          }
        },
        (data, code) => {
          if (code === "SUCCESS") {
            resolve(data)
          } else {
            reject(`slientAStudent->${new Error()}失败原因是${data}`)
          }
        }
      )
    })
  }
  // 设置学生发送消息的时间间隔
  setMessageInterval(interval) {
    return new Promise((resolve, reject) => {
      this.engine.sendMessage(
        {
          msgid: "203",
          msg: {
            msgtype: "40",
            data: JSON.stringify(interval)
          }
        },
        (data, code) => {
          if (code === "SUCCESS") {
            resolve(data)
          } else {
            reject(`setMessageInterval->${new Error()}失败原因是${data}`)
          }
        }
      )
    })
  }
  // 获取所有在线用户列表（包括老师）
  getAllUserList() {
    return new Promise((resolve, reject) => {
      this.engine.sendMessage(
        {
          msgid: "211"
        },
        (data, code) => {
          if (code === "SUCCESS") {
            resolve(data)
          } else {
            reject(`getAllUserList->${new Error()}失败原因是${data}`)
          }
        }
      )
    })
  }
  // 获取所有被禁列表
  getSilentUserList() {
    return new Promise((resolve, reject) => {
      this.engine.sendMessage(
        {
          msgid: "212"
        },
        (data, code) => {
          if (code === "SUCCESS") {
            resolve(data.msg.data.userlist)
          } else {
            reject(`getSilentUserList->${new Error()}失败原因是${data}`)
          }
        }
      )
    })
  }
  // 设置是否显示在线人数
  showOnlineUserCount() {
    return new Promise((resolve, reject) => {
      this.engine.sendMessage(
        {
          msgid: "203",
          msg: {
            msgtype: "42"
          }
        },
        (data, code) => {
          if (code === "SUCCESS") {
            resolve(data)
          } else {
            reject(`showOnlineUserCount->${new Error()}失败原因是${data}`)
          }
        }
      )
    })
  }
  hideOnlineUserCount() {
    return new Promise((resolve, reject) => {
      this.engine.sendMessage(
        {
          msgid: "203",
          msg: {
            msgtype: "43"
          }
        },
        (data, code) => {
          if (code === "SUCCESS") {
            resolve(data)
          } else {
            reject(`hideOnlineUserCount->${new Error()}失败原因是${data}`)
          }
        }
      )
    })
  }
  // 互动课件交互
  sendInteractiveClassData(data) {
    return new Promise((resolve, reject) => {
      this.engine.sendMessage(
        {
          msgid: "208",
          msg: data
        },
        (data, code) => {
          if (code === "SUCCESS") {
            resolve(data)
          } else {
            reject(`sendInteractiveClassData->${new Error()}失败原因是${data}`)
          }
        }
      )
    })
  }
  // 互动课件投票
  sendInteractiveClassPublicData(data) {
    return new Promise((resolve, reject) => {
      this.engine.sendMessage(
        {
          msgid: "209",
          msg: data
        },
        (data, code) => {
          if (code === "SUCCESS") {
            this.$logger.info(SIGNAL.RESEIVE_START_PUBLIC_VOTE_SUCCESS, data)
            resolve(data)
          } else {
            this.$logger.error(SIGNAL.RESEIVE_START_PUBLIC_VOTE_FAIL, data)
            reject(
              `sendInteractiveClassPublicData->${new Error()}失败原因是${data}`
            )
          }
        },
        TIMEROUT.RESEIVE_MESSAGE_TIMEOUT
      )
    })
  }

  // 初始化视频
  sendInitVideoMP4({
    url,
    progress_bar = "",
    seek_timestamp = "",
    status = "0",
    time_length = ""
  }) {
    return new Promise((resolve, reject) => {
      this.engine.sendMessage(
        {
          msgid: "203",
          msg: {
            msgtype: "44",
            // 保持数据格式一致
            data: JSON.stringify({
              progress_bar,
              seek_timestamp,
              status,
              time_length,
              url
            })
          }
        },
        (data, code) => {
          if (code === "SUCCESS") {
            this.$logger.info(SIGNAL.RESEIVE_INIT_VIDEO_MP4_SUCCESS, data)
            resolve(data)
          } else {
            this.$logger.error(SIGNAL.RESEIVE_INIT_VIDEO_MP4_FAIL, data)
            reject(`sendInitVideoMP4->${new Error()}失败原因是${data}`)
          }
        },
        TIMEROUT.RESEIVE_MESSAGE_TIMEOUT
      )
    })
  }

  // 播放视频
  sendPlayVideoMP4({ url, progress_bar, seek_timestamp }) {
    return new Promise((resolve, reject) => {
      this.engine.sendMessage(
        {
          msgid: "203",
          msg: {
            msgtype: "47",
            data: JSON.stringify({
              url,
              progress_bar,
              seek_timestamp
            })
          }
        },
        (data, code) => {
          if (code === "SUCCESS") {
            this.$logger.info(SIGNAL.RESEIVE_PLAY_VIDEO_MP4_SUCCESS, data)
            resolve(data)
          } else {
            this.$logger.error(SIGNAL.RESEIVE_PLAY_VIDEO_MP4_FAIL, data)
            reject(`sendPlayVideoMP4->${new Error()}失败原因是${data}`)
          }
        },
        TIMEROUT.RESEIVE_MESSAGE_TIMEOUT
      )
    })
  }

  // 暂停视频
  sendPauseVideoMP4({ url, progress_bar, seek_timestamp }) {
    return new Promise((resolve, reject) => {
      this.engine.sendMessage(
        {
          msgid: "203",
          msg: {
            msgtype: "46",
            data: JSON.stringify({
              url,
              progress_bar,
              seek_timestamp
            })
          }
        },
        (data, code) => {
          if (code === "SUCCESS") {
            this.$logger.info(SIGNAL.RESEIVE_PAUSE_VIDEO_MP4_SUCCESS, data)
            resolve(data)
          } else {
            this.$logger.error(SIGNAL.RESEIVE_PAUSE_VIDEO_MP4_FAIL, data)
            reject(`sendPauseVideoMP4->${new Error()}失败原因是${data}`)
          }
        },
        TIMEROUT.RESEIVE_MESSAGE_TIMEOUT
      )
    })
  }

  // 停止视频
  sendCloseVideoMP4() {
    return new Promise((resolve, reject) => {
      this.engine.sendMessage(
        {
          msgid: "203",
          msg: {
            msgtype: "49",
            data: ""
          }
        },
        (data, code) => {
          if (code === "SUCCESS") {
            this.$logger.info(SIGNAL.RESEIVE_CLOSE_VIDEO_MP4_SUCCESS, data)
            resolve(data)
          } else {
            this.$logger.error(SIGNAL.RESEIVE_CLOSE_VIDEO_MP4_FAIL, data)
            reject(`sendCloseVideoMP4->${new Error()}失败原因是${data}`)
          }
        },
        TIMEROUT.RESEIVE_MESSAGE_TIMEOUT
      )
    })
  }

  // seek视频
  sendSeekVideoMP4({ url, status, progress_bar, seek_timestamp }) {
    return new Promise((resolve, reject) => {
      this.engine.sendMessage(
        {
          msgid: "203",
          msg: {
            msgtype: "45",
            data: JSON.stringify({
              url,
              status,
              progress_bar,
              seek_timestamp
            })
          }
        },
        (data, code) => {
          if (code === "SUCCESS") {
            this.$logger.info(SIGNAL.RESEIVE_SEEK_VIDEO_MP4_SUCCESS, data)
            resolve(data)
          } else {
            this.$logger.error(SIGNAL.RESEIVE_SEEK_VIDEO_MP4_FAIL, data)
            reject(`sendSeekVideoMP4->${new Error()}失败原因是${data}`)
          }
        },
        TIMEROUT.RESEIVE_MESSAGE_TIMEOUT
      )
    })
  }

  // 大小屏切换：中心区域展示PPT
  sendSwitchVideoPPT(type) {
    return new Promise((resolve, reject) => {
      this.engine.sendMessage(
        {
          msgid: "203",
          msg: {
            msgtype: "53",
            data: type
          }
        },
        (data, code) => {
          if (code === "SUCCESS") {
            this.$logger.info(
              SIGNAL.RESEIVE_SEND_SWITCH_VIDEO_PPT_SUCCESS,
              data
            )
            resolve(data)
          } else {
            this.$logger.error(SIGNAL.RESEIVE_SEND_SWITCH_VIDEO_PPT_FAIL, data)
            reject(`sendSwitchVideoPPT->${new Error()}失败原因是${data}`)
          }
        },
        TIMEROUT.RESEIVE_MESSAGE_TIMEOUT
      )
    })
  }

  // 分页获取教室内学生列表
  getUsernameList(pageNum = 1, pageSize = 100) {
    let { userid, roomid, alias } = this.signalParams
    return new Promise((resolve, reject) => {
      this.engine.sendMessage(
        {
          msgid: "301",
          userid,
          roomid,
          msg: {
            msgtype: "52",
            userid,
            roomid,
            alias,
            data: JSON.stringify({
              page_num: JSON.stringify(pageNum),
              page_size: JSON.stringify(pageSize)
            })
          }
        },
        (data, code) => {
          if (code === "SUCCESS") {
            resolve(data.msg)
          } else {
            reject(`getUsernameList->${new Error()}失败原因是${data}`)
          }
        }
      )
    })
  }

  // 透传消息
  sendTransportData(text) {
    return new Promise((resolve, reject) => {
      this.engine.sendMessage(
        {
          msgid: "203",
          msg: {
            msgtype: "80",
            data: text
          }
        },
        (data, code) => {
          if (code === "SUCCESS") {
            this.$logger.info(SIGNAL.RESEIVE_TRANSPORT_DATA_SUCCESS, data)
            resolve(data)
          } else {
            this.$logger.error(SIGNAL.RESEIVE_TRANSPORT_DATA_FAIL, data)
            reject(`sendCloseVideoMP4->${new Error()}失败原因是${data}`)
          }
        },
        TIMEROUT.RESEIVE_MESSAGE_TIMEOUT
      )
    })
  }
  // 老师发送红包
  sendHongbaoData(data) {
    return new Promise((resolve, reject) => {
      this.engine.sendMessage(
        {
          msgid: "203",
          msg: {
            msgtype: "81",
            data
          }
        },
        (data, code) => {
          if (code === "SUCCESS") {
            this.$logger.info(SIGNAL.RESEIVE_SEND_HONGBAO_SUCCESS, data)
            resolve(data)
          } else {
            this.$logger.error(SIGNAL.RESEIVE_SEND_HONGBAO_FAIL, data)
            reject(`sendHongbaoData->${new Error(data)}`)
          }
        },
        TIMEROUT.RESEIVE_MESSAGE_TIMEOUT
      )
    })
  }

  // 取消绑定事件
  destroy() {
    this.removeAllListeners()
  }
}
export default Signal
